import { render, staticRenderFns } from "./ErrorServer.vue?vue&type=template&id=152525f5&scoped=true&"
import script from "./ErrorServer.vue?vue&type=script&lang=js&"
export * from "./ErrorServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152525f5",
  null
  
)

export default component.exports